import clsx from 'clsx';
import { ComponentPropsWithRef } from 'react';
import { badge, badgeStroke } from './badge.css';

export type BadgeProps = {
  color?: keyof typeof badge;
  interactive?: boolean;
  stroke?: boolean;
} & ComponentPropsWithRef<'span'>;

export const Badge = function Badge({
  ref,
  color = 'primary',
  interactive,
  stroke,
  className,
  ...rest
}: BadgeProps) {
  return (
    <span
      ref={ref}
      data-interactive={interactive ? '' : undefined}
      className={clsx(badge[color], stroke && badgeStroke, className)}
      {...rest}
    />
  );
};
